import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaCreditCard, FaQrcode, FaCheckCircle, FaArrowLeft } from 'react-icons/fa';

const Checkout = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [product, setProduct] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState('credit_card'); // 'credit_card' or 'pix'
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        if (location.state && location.state.product) {
            setProduct(location.state.product);
        } else {
            // Redirect back if no product selected
            navigate('/plataforma');
        }
    }, [location, navigate]);

    const handlePayment = () => {
        setLoading(true);
        // Simulate API call
        setTimeout(() => {
            setLoading(false);
            setSuccess(true);
            // Redirect after showing success message
            setTimeout(() => {
                navigate('/plataforma/cursos');
            }, 3000);
        }, 2000);
    };

    if (!product) return null;

    if (success) {
        return (
            <div className="form-container" style={{ maxWidth: '600px', margin: '2rem auto', textAlign: 'center', padding: '3rem' }}>
                <FaCheckCircle style={{ fontSize: '4rem', color: '#4CAF50', marginBottom: '1rem' }} />
                <h2 style={{ color: '#333', marginBottom: '1rem' }}>Pagamento Confirmado!</h2>
                <p style={{ color: '#666', fontSize: '1.1rem' }}>
                    Obrigado por sua compra. Você será redirecionado para seus cursos em instantes.
                </p>
            </div>
        );
    }

    return (
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <button
                onClick={() => navigate(-1)}
                style={{
                    background: 'none',
                    border: 'none',
                    color: '#666',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    marginBottom: '1rem',
                    cursor: 'pointer',
                    fontSize: '1rem'
                }}
            >
                <FaArrowLeft /> Voltar
            </button>

            <h2 style={{ marginBottom: '2rem', color: '#333' }}>Finalizar Compra</h2>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
                {/* Order Summary */}
                <div className="dashboard-card" style={{ height: 'fit-content' }}>
                    <h3 className="card-title">Resumo do Pedido</h3>
                    <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
                        <img
                            src={product.image}
                            alt={product.title}
                            style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '8px' }}
                        />
                        <div>
                            <h4 style={{ margin: '0 0 0.5rem 0', fontSize: '1.1rem' }}>{product.title}</h4>
                            <p style={{ margin: 0, color: '#666' }}>{product.type === 'ebook' ? 'Material Digital' : 'Curso Online'}</p>
                        </div>
                    </div>
                    <div style={{ borderTop: '1px solid #eee', paddingTop: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>Total:</span>
                        <span style={{ fontSize: '1.5rem', color: '#FF7EAF', fontWeight: 'bold' }}>
                            R$ {product.price.toFixed(2).replace('.', ',')}
                        </span>
                    </div>
                </div>

                {/* Payment Form */}
                <div className="dashboard-card">
                    <h3 className="card-title">Pagamento</h3>

                    {/* Tabs */}
                    <div style={{ display: 'flex', marginBottom: '1.5rem', borderBottom: '1px solid #eee' }}>
                        <button
                            onClick={() => setPaymentMethod('credit_card')}
                            style={{
                                flex: 1,
                                padding: '1rem',
                                background: 'none',
                                border: 'none',
                                borderBottom: paymentMethod === 'credit_card' ? '2px solid #FF7EAF' : 'none',
                                color: paymentMethod === 'credit_card' ? '#FF7EAF' : '#666',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '0.5rem'
                            }}
                        >
                            <FaCreditCard /> Cartão de Crédito
                        </button>
                        <button
                            onClick={() => setPaymentMethod('pix')}
                            style={{
                                flex: 1,
                                padding: '1rem',
                                background: 'none',
                                border: 'none',
                                borderBottom: paymentMethod === 'pix' ? '2px solid #FF7EAF' : 'none',
                                color: paymentMethod === 'pix' ? '#FF7EAF' : '#666',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '0.5rem'
                            }}
                        >
                            <FaQrcode /> PIX
                        </button>
                    </div>

                    {paymentMethod === 'credit_card' ? (
                        <form onSubmit={(e) => { e.preventDefault(); handlePayment(); }}>
                            <div className="form-group">
                                <label>Número do Cartão</label>
                                <input type="text" placeholder="0000 0000 0000 0000" required />
                            </div>
                            <div className="form-group">
                                <label>Nome no Cartão</label>
                                <input type="text" placeholder="Como impresso no cartão" required />
                            </div>
                            <div style={{ display: 'flex', gap: '1rem' }}>
                                <div className="form-group" style={{ flex: 1 }}>
                                    <label>Validade</label>
                                    <input type="text" placeholder="MM/AA" required />
                                </div>
                                <div className="form-group" style={{ flex: 1 }}>
                                    <label>CVV</label>
                                    <input type="text" placeholder="123" required />
                                </div>
                            </div>
                            <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading}>
                                {loading ? 'Processando...' : 'Confirmar Pagamento'}
                            </button>
                        </form>
                    ) : (
                        <div style={{ textAlign: 'center', padding: '1rem 0' }}>
                            <div style={{ background: '#f9f9f9', padding: '2rem', borderRadius: '8px', marginBottom: '1.5rem' }}>
                                <FaQrcode style={{ fontSize: '8rem', color: '#333' }} />
                            </div>
                            <p style={{ color: '#666', marginBottom: '1.5rem' }}>
                                Escaneie o QR Code acima ou copie o código abaixo para pagar.
                            </p>
                            <button className="btn-outline" style={{ width: '100%', marginBottom: '1rem' }}>
                                Copiar Código PIX
                            </button>
                            <button onClick={handlePayment} className="btn-primary" style={{ width: '100%' }} disabled={loading}>
                                {loading ? 'Verificando...' : 'Já fiz o pagamento'}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Checkout;
